module.exports = __webpack_public_path__ + "static/media/pricelist-banner.8fdf2605.jpg";